import { render, staticRenderFns } from "./course-list-navbar.vue?vue&type=template&id=c2228f10&scoped=true"
import script from "./course-list-navbar.vue?vue&type=script&lang=js"
export * from "./course-list-navbar.vue?vue&type=script&lang=js"
import style0 from "./course-list-navbar.vue?vue&type=style&index=0&id=c2228f10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2228f10",
  null
  
)

export default component.exports